import './style/index.js';

import _Select from './base/Select';

export type { SelectProps } from './base/Select';
export * from './type';

export const Select = _Select;
export default Select;
